import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterDepositReports from 'views/customers/reports/deposit_report/filterDepositReports'; // Importing filter for deposit reports
import TableDepositReport from 'views/customers/reports/deposit_report/tableDepositReports'; // Importing table for deposit reports
import DetailsDepositReport from 'views/customers/reports/deposit_report/detailsDepositReports'; // Importing details view for deposit reports
import RecordDepositReport from 'views/customers/reports/deposit_report/recordDepositReports'; // Importing record view for deposit reports
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit report view.
 */
export default class depositReportView extends JetView {
    /**
     * Configures the layout of the deposit report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Configuration for the right panel
            type: 'wide',
            minWidth: 200,
            rows: [RecordDepositReport], // Contains the record deposit report
        };
        const right2 = {
            // Alternative configuration for smaller screens
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordDepositReport], // Contains the record deposit report
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Toolbar columns
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        // Event handler for changing page size
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager for navigating through pages
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    animate: {
                        subtype: 'out',
                    },
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        // Event handler for export selection
                        onChange: function (value) {
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index on the current page
                            var last = first + size - 1; // Last item index on the current page
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        ); // Filter data for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Depósitos'),
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            ); // Filter data for export
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Depósitos'),
                                        autowidth: true,
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            // Left panel configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    id: 'toolbar-search',
                    elements: [
                        { view: 'label', label: _('Reporte de Depósitos') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon', // Search icon
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterDepositReports, // Filter component
                TableDepositReport, // Table component
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            // Accordion for advanced details
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Details section
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            scrollY: screen.width < 820 ? false : true, // Conditional scrolling
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left panel
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 for small screens
                            : avanc, // Use advanced details for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the deposit report view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                // Adjust for small screens
                var childs = $$('toolbar').getChildViews();
                $$('toolbar').removeView(childs[2]); // Remove pager for small screens
                $$('pagerA').define('group', 1); // Group pager items
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('toolbar-search').hide(); // Hide search toolbar for larger screens
            }
            $.fn.scrollBottom = function () {
                // Custom jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
